<template>
  <div class="game_details">
    <div class="game_details_inner">
      <breadcrumb :link-list="breadcrumbList"></breadcrumb>
      <div class="details">
        <div class="details_info">
          <div class="DI_base_img">
            <el-image
              :src="accountInfo.image"
              fit="cover"
              :preview-src-list="srcList">
              <div slot="placeholder" class="image-slot">
                图片加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          <div class="DI_base_content">
            <div class="DI_product_title">
              <div class="DIP_title">
                <div class="DIP_title_top">
                  <span>{{ accountInfo.game_name }}</span>{{ accountInfo.name }}
                </div>
                <div class="DIP_title_bot">
                  <div>金额换算：</div>
                  <div class="DIP_title_convert">1元={{ accountInfo.sell_price }}<span v-show="accountInfo.unit == '2'">万</span>金</div>
                  <div class="DIP_title_convert">1<span v-show="accountInfo.unit == '2'">万</span>金={{ accountInfo.unit_price }}元</div>
                </div>
              </div>
              <div class="collect">
                <div v-if="!accountInfo.is_collect" @click="collectClick" class="collectBtn" @mouseenter="collectBtn = true" @mouseleave="collectBtn=false">
                  <img v-show="!collectBtn" src="@/assets/image/AllGame/collect.png" alt="">
                  <img v-show="collectBtn" src="@/assets/image/AllGame/collectHover.png" alt="">
                  收藏
                </div>
                <div v-else @click="collectClick" class="isCollectBtn" >
                  <img src="@/assets/image/AllGame/isCollect.png" alt="">
                  已收藏
                </div>
              </div>
            </div>
            <div class="DI_prodct_price">
              <div id="DI_prodct_price">
                商品价格：
                <div>¥{{ accountInfo.sell_price }}</div>
              </div>
              <div id="DI_prodct_hot">
                <img src="@/assets/image/Home/topGamesIco.png" alt="">
                <span>{{ accountInfo.click }}</span>
              </div>
            </div>
            <div class="DI_prodct_zone">
              <div v-for="(categoryItem,index) in accountInfo.category" :key="index" id="DI_prodct_zone">
                <div class="zone_title">
                  {{ categoryItem.name.toString().slice(1,categoryItem.name.toString().length) }}：
                </div>
                <div class="zone_content">{{ categoryItem.value }}</div>
              </div>
            </div>
            <div class="DI_prodct_addDate">
              <div>
                库存：
                <span>{{ accountInfo.num }}</span>
              </div>
              <div>
                上架时间：
                <span>{{ accountInfo.add_time|moment }}</span>
              </div>
            </div>
            <div class="DI_btnGroup">
              <div class="DIBG_buyNum">
                <span>购买数量：</span>
                <el-input-number v-model="num" :min="1" :max="accountInfo.num" label="描述文字"></el-input-number>
              </div>
              <a target="_blank" :href="accountInfo.game_customer" class="onlineDealBtn">立即购买</a>
              <a class="cusSerBtn" target="_blank" :href="accountInfo.game_customer">
                <div>咨询客服</div>
              </a>
              <!--        <router-link :to="{name:'OnlineDeal',query:{id:id,game_id:game_id}}" class="onlineDealBtn">立即购买</router-link>-->
            </div>
          </div>
        </div>
        <div class="DI_productName">
          <div id="DI_productName">
            <div class="DI_productName_title">
              <span></span>
              商品描述
            </div>
            <div class="DI_productName_text">
              {{accountInfo.content}}
            </div>
          </div>
        </div>
        <div class="details_tabbar">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="交易须知" name="first">
              <div class="third_content">
                <div v-html="accountInfo.game_notice"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="交易流程" name="second">
              <div class="third_content">
  <!--              <div v-html="accountInfo.game_introduce"></div>-->
              </div>
            </el-tab-pane>
            <el-tab-pane label="业务介绍" name="third">
              <div class="third_content">
                <div v-html="accountInfo.game_introduce"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="交易群" name="fourth">
              <div class="fourth_content" v-if="qqGrounp && qqGrounp.length">
                <div class="fourth_content_item" v-for="(item,index) in qqGrounp" :key="index">
                  <div class="fourth_content_item_box" >
                    <div>
                      <img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                    </div>
                    <div class="qq_logo">
                      <img src="@/assets/image/AllGame/QQlogo.png" alt="">
                    </div>
                    <div class="group_name">{{ item.name }}</div>
                    <a class="add_group" target="_blank" :href="item.link">点击加群</a>
                  </div>
                </div>
              </div>
              <div class="groupEmpty" v-else>
                <empty-state
                  title="暂无可加入交易群"
                  description="您可以先咨询客服获取最新社群信息"
                  icon="el-icon-chat-dot-round"
                  icon-size="52"
                ></empty-state>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {apiGoldInfo, apiCollectGold, apiBargainAdd,apiBargainClcik} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  components: {
    breadcrumb,
    EmptyState
  },
  data () {
    return{
      //游戏名称
      game_name:'',
      //游戏id
      game_id:this.$route.query.game_id,
      //账号id
      id:this.$route.query.id,
      // 当前选中tabbar
      activeName:'first',
      // 交易qq群
      qqGrounp:[],
      //账号详情
      accountInfo:{
        image:''
      },
      //购买数量
      num:'',
      can_show:true,
      srcList:[],
      collectBtn:false,
      priceCutBtn:false,
      // 面包屑
      breadcrumbList: [
        {name: '全部游戏', link: '/allGame'},
        {name: '', link: '/selectgame', query: {game_id: this.$route.query.game_id}},
        {name: '游戏金币', link: '/selectgame', query: {game_id: this.$route.query.game_id}},
        {name: '金币详情'}
      ],
    }
  },
  methods: {
    handleClick(tab, event){
    },
    /**
     * 收藏按钮
     */
    collectClick(){
      if(this.$store.state.loginStatus){
        apiCollectGold({
          game_id:this.game_id,
          acc_id:this.id,
        }).then(res=>{
          this.accountInfo.is_collect = res.data.is_collect
        }).catch(err=>{
          this.$message({
            type:"error",
            center:true,
            message:err.msg
          })
        })
      }else {
        this.$message({
          type:"error",
          message:'尚未登录，请先登录。',
          center:true
        })
        this.$router.push({
          path:'/login',
          query:{
            Rurl: this.$route.fullPath,
            game_name:this.game_name,
            game_id:this.game_id,
            id:this.id,
          },
        })
      }
    },
    seeking_price_cuts_confirm(){
      apiBargainClcik({
        game_id:this.game_id,
        id:this.id,
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err.msg,
          center:true
        })
      })
      if(this.$store.state.loginStatus){
        let sell_price = 'block'
        if (this.accountInfo.sell_price == '0.00') {
          sell_price = 'none'
        }
        const h = this.$createElement;
        if(this.accountInfo.is_bargain){
          this.$msgbox({
            title:'',
            message: h('div', {class:'confirm_content'}, [
              h('div', {class:'confirm_original_price'}, '原价：'+this.accountInfo.price+''),
              h('div', {class:'confirm_my_bid'}, '我的出价：'+this.accountInfo.bargain_price+''),
              h('div', {class:'confirm_my_bid',style:"display:"+sell_price+""}, '卖家最低报价：'+this.accountInfo.sell_price+''),
              h('div',{class:'confirm_modify_bid'}, [
                h('div', {class:'confirm_modify_bid_text'}, '修改出价：'),
                h('input', {class:'confirm_modify_bid_input',attrs:{placeholder: "输入修改后的价格",id:"confirm_modify_bid_input"}}),
              ]),
              h('div', {class:'confirm_modify_bid_tips'},'（提示：24小时内只能求降价1次）'),
            ]),
            confirmButtonText: '确认修改',
            confirmButtonClass:'change_price_confirm_btn',
            customClass: 'change_price_confirm',
            closeOnClickModal:false,
            showClose:true,
            callback: action => {
              if(action === "confirm"){
                apiBargainAdd({
                  id:this.accountInfo.bargain_id,
                  price:document.getElementById("confirm_modify_bid_input").value
                }).then(res=>{
                  this.$message({
                    message:"修改成功",
                    center:true,
                    type:'success'
                  })
                }).catch(err=>{
                  this.$message({
                    message:err.msg,
                    center:true,
                    type:'error'
                  })
                })
              }
              document.getElementById("confirm_modify_bid_input").value = ''
            }
          });
        }else{
          this.$msgbox({
            title:'',
            message: h('div', {class:'confirm_content'}, [
              h('div', {class:'confirm_original_price'}, '原价：'+this.accountInfo.price+''),
              h('div',{class:'confirm_modify_bid'}, [
                h('div', {class:'confirm_modify_bid_text'}, '我的出价：'),
                h('input', {class:'confirm_modify_bid_input',attrs:{placeholder: "输入我出的价格",id:'confirm_modify_bid_input'}}),
              ]),
              h('div', {class:'confirm_modify_bid_tips'},'（提示：24小时内只能求降价1次）'),
            ]),
            confirmButtonText: '确认发起',
            confirmButtonClass:'change_price_confirm_btn',
            customClass: 'add_price_confirm',
            closeOnClickModal:false,
            showClose:true,
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                const price = document.getElementById("confirm_modify_bid_input").value
                if((price+'').includes('.')) {
                  this.$message({
                    type: "error",
                    message: '价格不支持小数',
                    center: true
                  })
                  return
                }
              }
              done()
            },
            callback: action => {
              if(action === "confirm"){
                apiBargainAdd({
                  game_id:this.game_id,
                  product_id:this.id,
                  price:document.getElementById("confirm_modify_bid_input").value
                }).then(res=>{
                  this.$message({
                    center:true,
                    message:"发起降价请求成功",
                    type:'success'
                  })
                  this.accountInfo.is_bargain = true
                  this.accountInfo.bargain_price = res.data.bargain_price

                }).catch(err=>{
                  this.$message({
                    message:err.msg,
                    center:true,
                    type:'error'
                  })
                })
              }
              document.getElementById("confirm_modify_bid_input").value = ''
            }
          });
        }
      }else {
        this.$message({
          type:"error",
          message:'尚未登录，请先登录。',
          center:true
        })
        this.$router.push({
          path:'/login',
          query:{
            Rurl: this.$route.fullPath,
            game_name:this.game_name,
            game_id:this.game_id,
            id:this.id,
          },
        })
      }

    },
    //初始化数据
    onLoad(){
      apiGoldInfo({
        id:this.id,
      }).then(res=>{
        this.can_show = res.data.can_show
        this.accountInfo = res.data
        this.srcList.push(res.data.image)
        this.game_name = res.data.game_name
        this.breadcrumbList[1].name = res.data.game_name
        this.qqGrounp = res.data.game_qun
        document.title= this.accountInfo.name
      })
    },
  },
  mounted () {
    //初始化数据
    this.onLoad()
  },
  watch: {
  },
  computed: {

  },
  created() {
    document.title = ''
  },
  beforeRouteLeave(to,from,next){
    if (to.name !== 'GoldDetails') {
      document.title = '游严选网络游戏账号交易代售平台-签署合同让交易享受法律保护'
      next()
    }
  }

}
</script>

<style lang="less" >
.first_content img,.second_content img{
  max-width: 100%;
  object-fit: cover;
  background: #D8D8D8;
  border-radius: 4px;
  margin: 0 0 9px 0;
}
.add_price_confirm{
  width: 500px !important;
  height: 300px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
  .el-message-box__header>.el-message-box__title{
    display: none;
  }
  .el-message-box__header,.el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }
  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .el-message-box__title{
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }
  .el-message-box__container{
    margin-top: 63px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }
  .change_price_confirm_btn{
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .change_price_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }
  .confirm_content{
    display: flex;
    flex-direction: column;
  }
  .confirm_original_price{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF5A1F);
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_my_bid{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .confirm_modify_bid_text{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }
  .confirm_modify_bid_input{
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }
  .confirm_modify_bid_tips{
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #BFBFBF;
    line-height: 22px;
    margin-left: 100px;
  }
  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}
.change_price_confirm{
  width: 500px !important;
  height: 320px !important;
  background: var(--bg-card, #FFFFFF) !important;
  border-radius: 4px !important;
  padding: 0;
  border: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
  .el-message-box__header>.el-message-box__title{
    display: none;
  }
  .el-message-box__header,.el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }
  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }
  .el-message-box__title{
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }
  .el-message-box__container{
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }
  .change_price_confirm_btn{
    margin-top: 20px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }
  .change_price_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
  }
  .confirm_content{
    display: flex;
    flex-direction: column;
  }
  .confirm_original_price{
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--primary, #FF5A1F);
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_my_bid{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
    margin-bottom: 20px;
  }
  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .confirm_modify_bid_text{
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }
  .confirm_modify_bid_input{
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }
  .confirm_modify_bid_tips{
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #BFBFBF;
    line-height: 22px;
    margin-left: 100px;
  }
  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}
</style>

<style lang="less" scoped>
/deep/ .el-tabs__nav-wrap::after {
  content: none;
}

/deep/ .el-tabs__header {
  height: 64px;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: none !important;
}

/deep/ .el-tabs__nav-scroll,
/deep/ .el-tabs__nav {
  height: 64px;
  display: flex;
  align-items: center;
}

/deep/ .el-tabs__item {
  height: 36px;
  padding: 0 18px !important;
  margin-right: 8px;
  border-radius: 4px;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 36px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

/deep/ .el-tabs__item:hover {
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__item.is-active {
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__active-bar.is-top {
  height: 0;
}

.game_details {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  background-color: var(--bg-page, #F7F5F2);

  .game_details_inner {
    width: 1200px;
    max-width: 100%;
    box-sizing: border-box;
  }

  .details {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .details_info {
      min-height: 468px;
      box-sizing: border-box;
      padding: 24px;
      display: flex;
      gap: 24px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      .DI_base_img {
        flex: 0 0 420px;
        width: 420px;
        height: 420px;
        overflow: hidden;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;

        /deep/ .el-image {
          display: block;
          width: 420px;
          height: 420px;
        }

        .image-slot {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: var(--text-muted, #9AA0AC);
          background: var(--bg-section, #F7F5F2);
        }
      }

      .DI_base_content {
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .DI_product_title {
          display: flex;
          justify-content: space-between;
          gap: 18px;
          min-height: 86px;

          .DIP_title {
            min-width: 0;

            .DIP_title_top {
              display: flex;
              align-items: flex-start;
              flex-wrap: wrap;
              gap: 8px 10px;
              margin: 0 0 12px;
              font-size: 22px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--text-main, #111827);
              line-height: 30px;

              span {
                flex: 0 0 auto;
                max-width: 150px;
                height: 26px;
                padding: 0 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background: var(--brand-blue-light, #F0EDE8);
                border: 1px solid rgba(26, 29, 36, 0.16);
                border-radius: 4px;
                font-size: 13px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                color: var(--brand-blue, #1A1D24);
                line-height: 24px;
              }
            }

            .DIP_title_bot {
              display: flex;
              flex-wrap: wrap;
              gap: 8px 10px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              line-height: 22px;

              .DIP_title_convert {
                padding: 3px 10px;
                background: var(--primary-soft, #FFF3E7);
                border: 1px solid rgba(255, 122, 26, 0.16);
                border-radius: 4px;
                color: var(--primary, #FF7A1A);
              }
            }
          }

          .collect {
            flex: 0 0 auto;
            display: flex;

            .collectBtn,
            .isCollectBtn {
              width: 96px;
              height: 36px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              cursor: pointer;
              transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

              img {
                width: 16px;
                height: 16px;
                margin: 0 6px 0 0;
                object-fit: contain;
              }
            }

            .collectBtn {
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
              border: 1px solid rgba(26, 29, 36, 0.22);
            }

            .collectBtn:hover {
              background: #FFFFFF;
              border-color: rgba(26, 29, 36, 0.45);
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
            }

            .isCollectBtn {
              color: #FFFFFF;
              background: var(--brand-blue, #1A1D24);
              border: 1px solid var(--brand-blue, #1A1D24);
            }
          }
        }

        .DI_prodct_price {
          min-height: 76px;
          box-sizing: border-box;
          padding: 14px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          background: linear-gradient(135deg, var(--primary-soft, #FFF3E7) 0%, #FFFFFF 100%);
          border: 1px solid rgba(255, 122, 26, 0.18);
          border-radius: 4px;

          #DI_prodct_price {
            min-width: 0;
            display: flex;
            align-items: baseline;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);

            div {
              min-width: 0;
              max-width: 320px;
              margin: 0 0 0 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 30px;
              font-family: PingFang SC, PingFang SC-Semibold;
              font-weight: 600;
              color: var(--primary, #FF7A1A);
              line-height: 36px;
            }
          }

          #DI_prodct_hot {
            flex: 0 0 auto;
            min-width: 86px;
            height: 36px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #FFFFFF;
            border: 1px solid rgba(26, 29, 36, 0.10);
            border-radius: 4px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--brand-blue, #1A1D24);

            img {
              width: 15px;
              height: 18px;
              margin: 0 6px 0 0;
              object-fit: contain;
            }
          }
        }

        .DI_prodct_zone {
          min-height: 82px;
          margin: 18px 0 8px;
          display: flex;
          flex-wrap: wrap;
          gap: 10px 12px;

          #DI_prodct_zone {
            width: calc((100% - 12px) / 2);
            min-height: 36px;
            box-sizing: border-box;
            padding: 7px 10px;
            display: flex;
            align-items: center;
            background: var(--bg-section, #F7F5F2);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;

            .zone_title,
            .zone_content {
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              line-height: 20px;
            }

            .zone_title {
              flex: 0 0 74px;
              max-width: 74px;
              color: var(--text-muted, #9AA0AC);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .zone_content {
              min-width: 0;
              color: var(--text-main, #111827);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .DI_prodct_promise {
          padding: 10px 0 11px  20px;
          border-top: 1px solid #F1F1F1;
          border-bottom: 1px solid #F1F1F1;
          display: flex;
          flex-direction: row;
          align-items: center;
          .promise_title{
            font-size: 14px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #8F8F8F;
            line-height: 20px;
            margin: 0 16px 0 0;
          }
          .promise_list{
            display: flex;
            flex-direction: row;
            .promise_item{
              display: flex;
              flex-direction: row;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #BFBFBF;
              margin: 0 40px 0 0;
              img{
                margin: 0 4px 0 0;
              }
            }
            .promise_item:last-of-type{
              margin: 0;
            }
          }
        }

        .DI_prodct_addDate {
          min-height: 50px;
          padding: 12px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          gap: 20px;
          border-top: 1px solid var(--border-soft, #E8E4DE);
          border-bottom: 1px solid var(--border-soft, #E8E4DE);

          div {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 24px;

            span {
              color: var(--text-main, #111827);
            }
          }
        }

        .DI_btnGroup {
          min-height: 52px;
          margin: 18px 0 0;
          display: flex;
          align-items: center;
          gap: 12px;

          .DIBG_buyNum {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);

            span {
              flex: 0 0 auto;
            }

            /deep/ .el-input-number {
              width: 128px;
              line-height: 34px;
            }

            /deep/ .el-input__inner {
              height: 34px;
              padding: 0 34px;
              border: 1px solid var(--border-soft, #E8E4DE);
              color: var(--text-main, #111827);
            }

            /deep/ .el-input-number__increase,
            /deep/ .el-input-number__decrease {
              width: 32px;
              height: 32px;
              background: var(--bg-section, #F7F5F2);
              border-color: var(--border-soft, #E8E4DE);
              color: var(--text-secondary, #5A5F6B);
              transition: color 0.2s ease, background-color 0.2s ease;
            }

            /deep/ .el-input-number__increase:hover,
            /deep/ .el-input-number__decrease:hover {
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
            }
          }

          .onlineDealBtn,
          .cusSerBtn {
            height: 52px;
            box-sizing: border-box;
            border-radius: 4px;
            font-size: 18px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            line-height: 52px;
            text-align: center;
            cursor: pointer;
            transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
          }

          .onlineDealBtn {
            flex: 1 1 auto;
            min-width: 150px;
            color: #FFFFFF;
            background: var(--primary, #FF7A1A);
            box-shadow: 0 10px 20px rgba(255, 122, 26, 0.20);
          }

          .onlineDealBtn:hover {
            background: var(--primary-hover, #F97316);
            box-shadow: 0 12px 24px rgba(255, 122, 26, 0.24);
          }

          .cusSerBtn {
            flex: 0 0 184px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--brand-blue, #1A1D24);
            background: var(--brand-blue-light, #F0EDE8);
            border: 1px solid rgba(26, 29, 36, 0.22);
          }

          .cusSerBtn:hover {
            background: #FFFFFF;
            border-color: rgba(26, 29, 36, 0.45);
            box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
          }
        }
      }
    }

    .DI_productName {
      box-sizing: border-box;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      #DI_productName {
        padding: 20px 24px;

        .DI_productName_title {
          display: flex;
          align-items: center;
          margin: 0 0 12px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 28px;

          span {
            width: 4px;
            height: 18px;
            margin: 0 10px 0 0;
            background: var(--brand-blue, #1A1D24);
            border-radius: 4px;
          }
        }

        .DI_productName_text {
          min-height: 24px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          line-height: 24px;
        }
      }
    }

    .DI_links {
      width: 1120px;
      height: 40px;
      background: #FFFFFF;
      padding: 20px 40px;
      margin: 0 0 10px 0;
      .labels{
        display: flex;
        flex-direction: row;
        a{
          flex: 1;
          text-align: center;
          margin: 0 11px 0 0;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: var(--text-secondary, #5A5F6B);
          padding: 11px 10px;
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
        }
        a:last-of-type{
          margin: 0;
        }
        a:hover{
          color: var(--primary, #FF5A1F);
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--bg-tag, #F0EDE8);
        }
      }
    }

    .details_tabbar {
      overflow: hidden;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      /deep/ .el-tabs__content {
        padding: 24px;
      }

      .first_content,
      .second_content {
        width: 100%;
        margin-bottom: 9px;
      }

      .third_content {
        min-height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        line-height: 24px;

        /deep/ img,
        img {
          max-width: 100%;
        }

        .third_content_item {
          margin-bottom: 50px;

          .content_item_title {
            display: flex;
            margin-bottom: 21px;

            div:first-of-type {
              margin-right: 20px;
            }

            div:last-of-type {
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
            }
          }

          .content_item_content {
            font-size: 15px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-main, #111827);
            line-height: 25px;

            img {
              width: 100%;
              height: 128px;
              object-fit: cover;
            }
          }
        }

        .third_content_item:last-of-type {
          margin-bottom: 0;
        }

        .third_content_item:first-of-type {
          margin-bottom: 41px;
        }
      }

      .fourth_content {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        .fourth_content_item {
          width: calc((100% - 16px) / 2);

          .fourth_content_item_box {
            min-height: 86px;
            box-sizing: border-box;
            padding: 16px;
            display: flex;
            align-items: center;
            gap: 12px;
            background: var(--bg-section, #F7F5F2);
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:hover {
              border-color: rgba(26, 29, 36, 0.30);
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
            }

            > div:first-of-type,
            .qq_logo {
              flex: 0 0 auto;

              img {
                width: 32px;
                height: 32px;
                object-fit: contain;
              }
            }

            > div:first-of-type img {
              width: 28px;
              height: 28px;
            }

            .group_name {
              min-width: 0;
              flex: 1 1 auto;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-main, #111827);
              line-height: 22px;
            }

            .add_group {
              flex: 0 0 auto;
              width: 92px;
              height: 34px;
              background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 34px;
              text-align: center;
              transition: box-shadow 0.2s ease;
            }

            .add_group:hover {
              box-shadow: 0 8px 18px rgba(26, 29, 36, 0.20);
            }
          }
        }
      }

      .groupEmpty {
        min-height: 220px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-section, #F7F5F2);
        border: 1px dashed var(--border-soft, #E8E4DE);
        border-radius: 4px;
      }
    }
  }

  .showFalse {
    width: 100%;
    min-height: 420px;
    box-sizing: border-box;
    padding: 50px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .showFalse_tip {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 0 32px;

      img {
        width: 229px;
        height: 150px;
        object-fit: cover;
      }

      #tip {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
        line-height: 20px;
      }
    }

    .showFalse_btnG {
      display: flex;
      flex-direction: column;
      align-items: center;

      a {
        width: 300px;
        height: 50px;
        border-radius: 4px;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
      }

      #back {
        margin: 0 0 10px;
        color: #FFFFFF;
        background: var(--primary, #FF7A1A);
        box-shadow: 0 10px 20px rgba(255, 122, 26, 0.20);
      }

      #back:hover {
        background: var(--primary-hover, #F97316);
      }

      .cusSer {
        color: var(--brand-blue, #1A1D24);
        background: var(--brand-blue-light, #F0EDE8);
        border: 1px solid rgba(26, 29, 36, 0.22);
      }

      .cusSer:hover {
        background: #FFFFFF;
        border-color: rgba(26, 29, 36, 0.45);
      }
    }
  }
}

</style>
